import React from "react";
import JobsWrap from "./JobsWrap";

function Jobs(props) {
    return (
        <>
            <JobsWrap/>
        </>
    )
}

export default Jobs;
